import styled from "styled-components";
import { getTheme, } from "@bracket/ui";
import { Text as Tx, type TextProps, } from "./Text";
import type { Optional, } from "@bracket/types";
import type { ReactNode, } from "react";



export declare type LinkToProps = Optional<TextProps, "children"> & {
	url: string;
	label?: string;
	children?: string | string[] | ReactNode;
	as?: "span"|"a";
}


export const LinkTo = ({ url, label, children, as = "a", ...rest }: LinkToProps) => {
	label = label || children as string || url;
	return (
		<LinkToText href={url} target="_blank" rel="noopener noreferrer">
			<Tx {...rest} as={"span"}>{label}</Tx>
		</LinkToText>
	)
}

export const LinkToText = styled.a`
	text-decoration: none;
	> span, > p {
		cursor: pointer;
		color: ${() => getTheme().primary };
		&:hover {
			text-decoration: underline;
		}
		&:visited {
			opacity: 0.8;
		}
	}
`;
